<template>
  <div>
    <h2>Survival plot</h2>
    <a-row>
      <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }"
        >Gene:
        <br />
        <a-input
          style="width: 60%"
          :placeholder="gene"
          :disabled="disabled"
        ></a-input>
        <br />
        <br />
        Group Cutoff
        <br />
        <a-radio-group style="width: 100%" v-model="value" @change="onChange">
          <a-radio key="1" :value="'median'" :style="radioStyle" checked
            >Median</a-radio
          >
          <a-radio key="2" :value="'bestP'" :style="radioStyle"
            >Auto select best pvalue</a-radio
          >
          <!-- <a-radio key="3" :value="'custome'" :style="radioStyle"
            >Custome</a-radio
          > -->
        </a-radio-group>
        <!-- <div v-if="value === 'custome'">
          <a-row>
            <a-col :span="12">
              High(%)
              <a-input-number
                :min="1"
                :max="100"
                :default-value="50"
                v-model="highPercent"
                @change="onChange"
            /></a-col>
            <a-col :span="12">
              Low(%)
              <a-input-number
                :min="1"
                :max="100"
                :default-value="50"
                v-model="lowPercent"
                @change="onChange2"
            /></a-col>
          </a-row>
        </div> -->
      </a-col>
      <a-col :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 12 }">
        Cancer:
        <a-select
          v-model="cancerdemo"
          style="width: 100%"
          placeholder="select one or more perturbed gene"
          option-label-prop="label"
        >
          <a-select-option v-for="ca in this.cancerlist" :key="ca" :label="ca">
            {{ ca }}
          </a-select-option>
        </a-select>
        <br />
        <br />
        Color palette:
        <div @click="colorInputClick">
          <a-input
            disabled
            :value="color"
            @click="colorInputClick"
            addon-before="Tumor:"
          ></a-input>
        </div>
        <div v-show="isShowColors" class="color-select-layer">
          <sketch-picker
            v-model="color"
            @input="colorValueChange"
          ></sketch-picker>
        </div>

        <div @click="colorInputClick2" style="margin-top: 5px">
          <a-input
            disabled
            :value="color2"
            @click="colorInputClick2"
            addon-before="Normal:"
          ></a-input>
        </div>
        <div v-show="isShowColors2" class="color-select-layer">
          <sketch-picker
            v-model="color2"
            @input="colorValueChange2"
          ></sketch-picker>
        </div>
        <br />
        Dimensions for pdf:
        <a-row>
          <a-col :span="12">
            <a-input type="text" addon-before="Width : " v-model="pWidth"
          /></a-col>
          <a-col :span="12">
            <a-input type="text" addon-before="Height: " v-model="pHeight"
          /></a-col>
        </a-row>
      </a-col>
    </a-row>
    <br />
    <a-button type="primary" style="float: right" @click="plotSurvival()"
      >Plot</a-button
    >
    <br />
    <br />
    <a-card
      style="width: 100%; margin-top: 10px; height: 550px"
      v-show="visible"
    >
      <a-spin
        size="large"
        :spinning="survivalplot_visible"
        :indicator="indicator"
      >
        <object
          :data="this.survivalplotlinks"
          width="100%"
          height="550"
        ></object>
      </a-spin>
    </a-card>
  </div>
</template>
<script>
import axios from "axios";
import { Sketch } from "vue-color";
export default {
  components: {
    "sketch-picker": Sketch,
  },
  props: ["ensgId"],
  name: "survival",
  methods: {
    onChange(e) {
      console.log("radio checked", e.target.value);
    },
    // 颜色输入框点击事件处理1
    colorInputClick() {
      this.isShowColors = !this.isShowColors;
    },
    colorInputOut() {
      this.isShowColors = !this.isShowColors;
    },
    // 颜色值改变事件处理
    colorValueChange(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color = val.hex;
    },
    // 颜色输入框点击事件处理2
    colorInputClick2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    colorInputOut2() {
      this.isShowColors2 = !this.isShowColors2;
    },
    // 颜色值改变事件处理
    colorValueChange2(val) {
      console.log(val);

      // 取颜色对象的十六进制值
      this.color2 = val.hex;
    },
    plotSurvival() {
      this.visible = true;
      this.survivalplotlinks = "";
      this.survivalplot_visible = true;
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/01survivalPlot.php",
          {
            params: {
              cancer: this.cancerdemo,
              ensgId: this.ensgId,
              genename: this.gene,
              color1: String(this.color).split("#")[1],
              color2: String(this.color2).split("#")[1],
              plottype: this.value,
              highP: this.highPercent,
              lowP: this.lowPercent,
              pWidth: this.pWidth,
              pHeight: this.pHeight,
            },
          }
        )
        .then((response) => {
          this.survivalplot_visible = false;
          if (response.data != "failed") {
            this.survivalplot_visible = false;
            this.$message.success(response.data + ".pdf plotted!", 6);
            this.survivalplotlinks =
              "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
              response.data +
              ".pdf#zoom=60";
            console.log(this.survivalplotlinks);
            console.log(response.data);
          } else {
            this.$message.error("step error, please contact us for a help!", 6);
          }
        });
    },
  },
  data() {
    return {
      indicator: <a-icon type="loading" style="font-size: 50px" spin />,
      gene: this.$route.query.gene,
      disabled: true,
      value: "median",
      //配置
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      lowPercent: 50,
      highPercent: 50,
      cancerdemo: "ACC",
      cancerlist: [
        "ACC",
        "BLCA",
        "BRCA",
        "CESC",
        "CHOL",
        "COAD",
        "DLBC",
        "ESCA",
        "GBM",
        "HNSC",
        "KICH",
        "KIRC",
        "KIRP",
        "LAML",
        "LGG",
        "LIHC",
        "LUAD",
        "LUSC",
        "MESO",
        "OV",
        "PAAD",
        "PCPG",
        "PRAD",
        "READ",
        "SARC",
        "SKCM",
        "STAD",
        "TGCT",
        "THCA",
        "THYM",
        "UCEC",
        "UCS",
        "UVM",
      ],
      //color #不得行
      color: "#AA4643",
      isShowColors: false,
      color2: "#4572a7",
      isShowColors2: false,
      //画图结果
      visible: false,
      // 文件的宽度
      pWidth: 8,
      pHeight: 8,
      survivalplot_visible: true,
      survivalplotlinks: "",
    };
  },
};
</script>
